export default __webpack_public_path__ + "static/media/icon_overview_m.4be13179.svg";